import React, { useContext, useState, useEffect, useRef } from 'react'
import {dataContext,localestr,validDate,allTypes} from '../utils.js'
//import md5 from '../md5';
import EditCat from './EditCat'
import EditFld from './EditFld'
import EditDateTime from './EditDateTime.js';
import EditDate from './EditDate.js';


//може бути 
//+-number число (кнопка калькулятор),
//+text текст
//+date дата (стандартний тип)
//+check галочка
//+-rad* радіо перемикач
//+-cat* вибір довідника
//doc* вибір документа
//+-sel* перелічення із глобальних
//+pass пароль
//html ?
//undef не визначено (кнопка вибору типу)
//вибирати можна number, text, date, cat, doc, sel


function Edit({title,Value,typeVal,setVal,disabled=false,style=undefined,id=undefined,isActive=false,userData=null}){
    let editType

    if (typeVal !== undefined) editType=typeVal
    else if (!isNaN(+Value)) editType='number'
    else if (validDate(Value)) editType='date'
    else if (typeof Value === 'string') editType='text'
    else if (typeof Value === 'object') editType=Value.type||'undef'
    else editType='undef'

    const [currType, setType] = useState(editType);
    const targetRef = useRef()

    let data=[]
    const context=useContext(dataContext)
    data=context.data[currType]
    if (userData&&typeVal === 'selUserType') data=[...userData]
    else if (typeof data === 'undefined') data=[]

    const changeHandler=(e)=>{
        if (currType.substring(0, 6)==='number') setVal(!isNaN(+e)?e:'')
        else if (currType==='text') setVal(e)
        else if (currType==='longtext') setVal(e)
        //else if (currType==='pass') setVal(md5(e))
        else if (currType==='pass') setVal(e)
        else if (currType==='date') setVal(e)
        else if (currType==='time') setVal(e)
        else if (currType==='datetime') setVal(new Date(e))
        else if (currType==='check') setVal(e==='1'?'1':'0')
        else if (currType==='color') setVal({name:'color',src:e})
        else if (currType==='crtfile'||currType==='keyfile'||currType==='licfile') setVal(e)
        else if (currType.substring(0, 3)==='rad') setVal(e)
        else if (currType.substring(0, 3)==='sel') setVal(e)
        else if (currType.substring(0, 3)==='cat') setVal({...e,obj_type:currType})
        else if (currType.substring(0, 3)==='fld') setVal({...e,obj_type:currType})
        if(e===null && typeVal === undefined) setType('undef')
    }

    const postChange=(e)=>{
        if (currType.substring(0, 6)==='number'&&currType.substring(0, 6)!==currType) {
            const w=currType.substring(6)
            if (!isNaN(+w)) setVal(parseFloat(e).toFixed(parseInt(w)))
        }
    }

    function setFocus(el){
        if (!el) return
        if (!isActive) return
        if (document.activeElement.nodeName==='INPUT') return
        if (document.activeElement.nodeName==='TEXTAREA') return
        el.focus()
        if (currType==='longtext') el.selectionStart = el.value.length
    }

    // eslint-disable-next-line
    useEffect(() => {
        if (userData&&typeVal === 'selUserType') return
        //if (currType.substring(0, 3)==='rad' || currType.substring(0, 3)==='sel' || currType.substring(0, 3)==='cat' || currType.substring(0, 3)==='doc'){
        if (currType.substring(0, 3)==='rad' || currType.substring(0, 3)==='sel' || currType.substring(0, 3)==='doc'){
            if (context.data[currType] === undefined) {
                context.getData(currType)
            } 
        }
        if (typeVal !== undefined && currType!==typeVal) setType(typeVal)
    },)

    let Val=Value || ''
    if (currType.substring(0, 3)==='sel' && typeof Val === 'object'){
        if(Val.value) Val=Val.value
    }
    if (currType.substring(0, 3)==='rad' && typeof Val === 'object'){
        if(Val.value) Val=Val.value
    }
    if (currType.substring(0, 3)==='cat' && Val !== ''){
        if(!Val.id) Val=''
        else Val=Val.id
    }
    if (currType==='datetime'){
        if(Value&&!isNaN(Value)&&validDate(Value))
        Val=Value.getFullYear()+'-'+(Value.getMonth() + 1).toString().padStart(2, '0')+'-'+Value.getDate().toString().padStart(2, '0')+'T'+Value.getHours().toString().padStart(2, '0')+':'+Value.getMinutes().toString().padStart(2, '0')
        else Val=null
    }
    if (currType==='check') Val=''+Value || ''
    if(!Val&&currType==='color') Val={name:'color',src:'#ffffff'}
    if(currType==='color'&&!Val.src) Val={name:'color',src:'#ffffff'}
    if(!Val) Val=''

    let item=''
    const elId=id||'id'+Math.random()

//console.log(isActive)

    if(style===undefined){
        style={display:'inline-flex',width:'100%',fontSize:'inherit',fontFamily:'inherit',padding:'0'}
        if (currType==='text') style={display:'inline-flex',width:'calc(100% - 4px)',fontSize:'inherit',fontFamily:'inherit',padding:'0'}
        if (currType==='longtext') style={display:'inline-flex',width:'calc(100% - 6x)',fontSize:'inherit',fontFamily:'inherit',padding:'0'}
        if (currType.substring(0, 6)==='number') style={display:'inline-flex',width:'calc(100% - 4px)',textAlign:'right',fontSize:'inherit',fontFamily:'inherit',padding:'0'}
    }

    if (currType.substring(0, 6)==='number') item=<input title={title} ref={el=>{setFocus(el);return targetRef}} style={style} id={elId} disabled={disabled} type='number' value={Val} onChange={(e)=>{changeHandler(e.target.value)}} onBlur={(e)=>postChange(e.target.value)} onFocus={(e)=>{setTimeout(()=>e.target.select(),100)}} />
    else if (currType==='text') item=<input title={title} ref={el=>{setFocus(el);return targetRef}} style={style} id={elId} disabled={disabled} type='text' value={Val} onChange={(e)=>{changeHandler(e.target.value)}} />
    else if (currType==='longtext') item=<textarea title={title} ref={el=>{setFocus(el);return targetRef}} style={style} id={elId} disabled={disabled} type='text' value={Val} onChange={(e)=>{changeHandler(e.target.value)}} />
    else if (currType==='pass') item=<input title={title} ref={el=>{setFocus(el);return targetRef}} style={style} id={elId} disabled={disabled} type='password' value={Val} onChange={(e)=>{changeHandler(e.target.value)}} />
    //else if (currType==='date') item=<input ref={el=>{setFocus(el);return targetRef}} style={style} id={elId} disabled={disabled} type='date' value={Val} onChange={(e)=>{changeHandler(e.target.value)}} />
    else if (currType==='date') item=<EditDate title={title} style={style} id={elId} disabled={disabled}  Value={Value}  setVal={changeHandler} />
    else if (currType==='time') item=<input title={title} ref={el=>{setFocus(el);return targetRef}} style={style} id={elId} disabled={disabled} type='time' value={Val} onChange={(e)=>{changeHandler(e.target.value)}} />
    //else if (currType==='datetime') item=<input ref={el=>{setFocus(el);return targetRef}} style={style} id={elId} disabled={disabled} type='datetime-local' value={Val} onChange={(e)=>{changeHandler(e.target.value)}} />
    else if (currType==='datetime') item=<EditDateTime title={title} style={style} id={elId} disabled={disabled}  Value={Value}  setVal={changeHandler} />
    else if (currType==='check') item=<input title={title} ref={el=>{setFocus(el);return targetRef}} id={elId} disabled={disabled} type='checkbox' checked={Val==='1'} onChange={(e)=>{changeHandler(e.target.checked?'1':'0')}} />
    else if (currType==='color') item=<input title={title} ref={el=>{setFocus(el);return targetRef}} style={style} id={elId} disabled={disabled} type='color' value={Val.src} onChange={(e)=>{changeHandler(e.target.value)}} />
    else if (currType==='crtfile') item=<input title={title} ref={el=>{setFocus(el);return targetRef}} style={style} id={elId} disabled={disabled} type='file' accept='.cer,.crt' onClick={()=>changeHandler(null)} onChange={(e)=>{changeHandler(e.target.files[0])}} />
    else if (currType==='keyfile') item=<input title={title} ref={el=>{setFocus(el);return targetRef}} style={style} id={elId} disabled={disabled} type='file' accept='.dat,.zs2,.jks' onClick={()=>changeHandler(null)} onChange={(e)=>{changeHandler(e.target.files[0])}} />
    else if (currType==='licfile') item=<input title={title} ref={el=>{setFocus(el);return targetRef}} style={style} id={elId} disabled={disabled} type='file' accept='.bin' onClick={()=>changeHandler(null)} onChange={(e)=>{changeHandler(e.target.files[0])}} />
    else if (currType.substring(0, 3)==='rad') item=<div title={title} style={{...style,display:'flex',flexDirection:'row',whiteSpace:'nowrap'}}>{data.map((el,idx)=>{return <label key={idx}><input id={elId} disabled={disabled} type='radio' name={elId} value={el.value} checked={Val===el.value} onChange={(e)=>{changeHandler(e.target.value)}} /> {localestr(el.name)} </label> })}</div>
    else if (currType.substring(0, 3)==='sel') item=<select title={title} ref={el=>{setFocus(el);return targetRef}} style={style} id={elId} value={Val} disabled={disabled} onChange={(e)=>{changeHandler(e.target.value)}}><option value=''></option>{data.map((el,idx)=>{return <option key={idx} value={el.value}>{localestr(el.name)}</option> })}</select>
    else if (currType.substring(0, 3)==='cat') item=<EditCat title={title} Value={Value} typeVal={currType} setVal={changeHandler} disabled={disabled} style={style} id={elId} />
    else if (currType.substring(0, 3)==='fld') item=<EditFld title={title} Value={Value} typeVal={currType} setVal={changeHandler} disabled={disabled} style={style} id={elId} />
    else if (currType==='undef') item=<select title={title} ref={el=>{setFocus(el);return targetRef}} style={style} id={elId} disabled={disabled} onChange={(e)=>{setType(e.target.value)}}><option value=''>{localestr('тип значення')}</option>{allTypes.map((el,idx)=>{return <option key={idx} value={el.value}>{localestr(el.name)}</option> })}</select>

    return(
        <>{item}</>
    )
}

export default Edit